import { render } from "./HowMuchSelfScreen.vue?vue&type=template&id=3d6ca14a"
import script from "./HowMuchSelfScreen.vue?vue&type=script&lang=js"
export * from "./HowMuchSelfScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__